import React, { memo } from 'react';

type FormatStringType = {
  oldString: string;
  search?: string;
};

export const HighlightedMultipleSearch = memo(
  ({ oldString, search }: FormatStringType) => {
    if (!search?.trim()) {
      return <span>{oldString}</span>;
    }

    const parts = oldString.split(
      new RegExp(`(${search.trim().split(' ').join('|')})`, 'gi'),
    );

    return (
      <span>
        {parts.map((part, i) => (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            style={i === 1 ? { color: '#7EB3BD' } : {}}
          >
            {part}
          </span>
        ))}
      </span>
    );
  },
);
